/**
 * We have issues with console log overtaken by raygun.
 * This solution does not work: https://github.com/MindscapeHQ/raygun4js/issues/348
 * But blackboxing (add to ignore list) seems to be the way to go. https://github.com/MindscapeHQ/raygun4js/issues/348#issuecomment-587065453
 */

import { APP_VER } from 'app/core/config';
import { isRaygunEnabled } from 'app/core/errors/errors.lib';
import rg4js from 'raygun4js';

export const raygunInit = () => {
  if (isRaygunEnabled() && process.env.NODE_ENV === 'production') {
    rg4js('apiKey', isRaygunEnabled() as string);
    rg4js('disableAutoBreadcrumbsConsole');
    rg4js('enableCrashReporting', true);
    rg4js('setVersion', APP_VER);
  }
};

export const raygunSendError = (error: Error) => {
  if (isRaygunEnabled() && process.env.NODE_ENV === 'production') {
    rg4js('send', error);
  }
};

export const raygunSetUser = (userId: string, email: string, isAnonymous?: boolean) => {
  if (isRaygunEnabled() && process.env.NODE_ENV === 'production') {
    rg4js('setUser', {
      identifier: email, // A unique ID, email address, or another ID such as a UUID
      isAnonymous: isAnonymous ?? false, // Indicates whether the user is anonymous or not
      uuid: userId, // Optional device identifier
    });
  }
};
